import { render, staticRenderFns } from "./JointsConfiguratorSelectorPopup.vue?vue&type=template&id=700f28f9&scoped=true"
import script from "./JointsConfiguratorSelectorPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./JointsConfiguratorSelectorPopup.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./JointsConfiguratorSelectorPopup.vue?vue&type=style&index=0&id=700f28f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700f28f9",
  null
  
)

export default component.exports